// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type {
  OperationResource,
  ErrorModel,
  ErrorAdditionalInfo,
  CloudError,
  Vault,
  VaultProperties,
  UpgradeDetails,
  VaultUpgradeState,
  TriggerType,
  PrivateEndpointConnectionVaultProperties,
  PrivateEndpointConnection,
  ProvisioningState,
  PrivateEndpoint,
  PrivateLinkServiceConnectionState,
  PrivateEndpointConnectionStatus,
  VaultSubResourceType,
  VaultPrivateEndpointState,
  VaultPropertiesEncryption,
  CmkKeyVaultProperties,
  CmkKekIdentity,
  InfrastructureEncryptionState,
  VaultPropertiesMoveDetails,
  ResourceMoveState,
  BackupStorageVersion,
  PublicNetworkAccess,
  MonitoringSettings,
  AzureMonitorAlertSettings,
  AlertsState,
  ClassicAlertSettings,
  CostManagementSettings,
  GranularityLevel,
  RestoreSettings,
  CrossSubscriptionRestoreSettings,
  CrossSubscriptionRestoreState,
  VaultPropertiesRedundancySettings,
  StandardTierStorageRedundancy,
  CrossRegionRestore,
  SecuritySettings,
  ImmutabilitySettings,
  ImmutabilityState,
  ImmutabilityConfiguration,
  ImmutabilityType,
  SoftDeleteSettings,
  SoftDeleteState,
  EnhancedSecurityState,
  MultiUserAuthorization,
  SourceScanConfiguration,
  State,
  AssociatedIdentity,
  IdentityType,
  SecureScoreLevel,
  BcdrSecurityLevel,
  IdentityData,
  ResourceIdentityType,
  UserIdentity,
  Sku,
  SkuName,
  TrackedResource,
  Resource,
  SystemData,
  CreatedByType,
  ClientDiscoveryValueForSingleApi,
  ClientDiscoveryDisplay,
  ClientDiscoveryForProperties,
  ClientDiscoveryForServiceSpecification,
  ClientDiscoveryForLogSpecification,
  ErrorDetail,
  PatchVault,
  PatchTrackedResource,
  ErrorResponse,
  DeletedVault,
  DeletedVaultProperties,
  ProxyResource,
  DeletedVaultUndeleteInput,
  DeletedVaultUndeleteInputProperties,
  PrivateLinkResource,
  PrivateLinkResourceProperties,
  CertificateRequest,
  RawCertificateData,
  AuthType,
  VaultCertificateResponse,
  ResourceCertificateDetails,
  ResourceCertificateDetailsUnion,
  ResourceCertificateAndAadDetails,
  ResourceCertificateAndAcsDetails,
  ReplicationUsage,
  MonitoringSummary,
  JobsSummary,
  VaultUsage,
  UsagesUnit,
  NameInfo,
  VaultExtendedInfoResource,
  VaultExtendedInfo,
  CheckNameAvailabilityParameters,
  CheckNameAvailabilityResult,
  ResourceCapabilities,
  CapabilitiesProperties,
  DNSZone,
  ResourceCapabilitiesBase,
  CapabilitiesResponse,
  CapabilitiesResponseProperties,
  DNSZoneResponse,
} from "./models.js";
export {
  KnownVaultUpgradeState,
  KnownTriggerType,
  KnownProvisioningState,
  KnownPrivateEndpointConnectionStatus,
  KnownVaultSubResourceType,
  KnownVaultPrivateEndpointState,
  KnownInfrastructureEncryptionState,
  KnownResourceMoveState,
  KnownBackupStorageVersion,
  KnownPublicNetworkAccess,
  KnownAlertsState,
  KnownGranularityLevel,
  KnownCrossSubscriptionRestoreState,
  KnownStandardTierStorageRedundancy,
  KnownCrossRegionRestore,
  KnownImmutabilityState,
  KnownImmutabilityType,
  KnownSoftDeleteState,
  KnownEnhancedSecurityState,
  KnownMultiUserAuthorization,
  KnownState,
  KnownIdentityType,
  KnownSecureScoreLevel,
  KnownBcdrSecurityLevel,
  KnownResourceIdentityType,
  KnownSkuName,
  KnownCreatedByType,
  KnownAuthType,
  KnownUsagesUnit,
  KnownVersions,
} from "./models.js";
